const $ = require('jquery');

$(document).ready(function() {

  $('.header__menu-button').on('click', function() {
    $(this).parents('.header').toggleClass('header--is-open');
  });

});
